import styled from 'styled-components'

export const Container = styled.div`
  width: 15rem;
`

export const Text = styled.div`
  color: #367f98;
  font-weight: 500;
`